<template>
    <div>
        <div class="hypo-alert" v-if="notification.visible">
            <mds-alert
                :size="notification.size"
                :variation="notification.variation"
                :title="notification.title"
                :persistent="notification.persistent"
                @mds-alert-dismissed="notificationDismissed"
            >
                {{ notification.text }}
            </mds-alert>
        </div>
        <div class="hypo-alert-stack" v-if="notificationStack.visible">
            <div class="notification" v-for="notification in notificationStack.stack" :key="notification.key">
                <mds-alert
                    v-if="notification.visible"
                    :size="notification.size"
                    :variation="notification.variation"
                    :title="notification.title"
                    :persistent="notification.persistent"
                    @mds-alert-dismissed="hideStackedNotification(notification.key)"
                >
                    {{ notification.text }}
                </mds-alert>
            </div>
        </div>
    </div>
</template>

<script>
import MdsAlert from "@mds/alert";
import { mapState } from "vuex";
export default {
    name: "hypo-alert",
    components: { MdsAlert },
    computed: { ...mapState("notifications", ["notification", "notificationStack"]) },
    watch: {
        notification: {
            handler(newVal) {
                // duration = 0 means stay visible until click on close
                if (newVal.visible === true && this.notification.duration > 0) {
                    setTimeout(() => {
                        this.$store.dispatch("notifications/clearNotification");
                    }, this.notification.duration);
                }
            }
        }
    },
    methods: {
        notificationDismissed() {
            this.$store.dispatch("notifications/clearNotification");
        },
        hideStackedNotification(key) {
            this.$store.dispatch("notifications/clearStackedNotification", key);
        }
    }
};
</script>

<style lang="scss">
.hypo-alert {
    position: fixed;
    top: 0;
    right: 50%;
    margin-right: -25%;
    width: 50vw;
    z-index: 10;
    .mds-alert__dismiss-button___hypo {
        height: 12px;
        top: 8px !important;
        right: 20px !important;
    }
}

.hypo-alert-stack {
    position: fixed;
    top: 0;
    right: 50%;
    margin-right: -25%;
    width: 50vw;
    z-index: 10;
    .notification {
        margin-bottom: 20px;
        .mds-alert__dismiss-button___hypo {
            height: 12px;
            top: 8px !important;
            right: 20px !important;
        }
    }
}
</style>
